import actions from './actions';

const {
  LIST_PAGOS_REGISTRADOS,
  LIST_PAGOS_REGISTRADOS_SELECTBOX,
  READ_PAGOS_REGISTRADOS,   
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const pagosRegistradosCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_PAGOS_REGISTRADOS:
      return {
        ...state,
        data: data
      }
    case LIST_PAGOS_REGISTRADOS_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case READ_PAGOS_REGISTRADOS:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default pagosRegistradosCrudReducer;
